// @ts-nocheck
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { generateContent, SOPCopyResult } from "../../apiFunctions/sop/content";
import { getSop } from "../../apiFunctions/sop/utils";
import { NotificationStatus, setNotification } from "../../store/main/actions";
import {
  setCopies,
  setGenerations,
  setToggleResults,
} from "../../store/sop/actions";
import { Listbox } from "@headlessui/react";

import { parseError } from "../../utils/common";
import MainButton from "../generic/buttons/mainButton";
import CountedInput from "../generic/inputs/CountedInput";
import {
  setInputs as setReduxInputs,
  setSopLength,
} from "../../store/sop/actions";
import GenerationLoading from "./overlay/generationLoading";
import CountedTextArea from "../generic/inputs/CountedTextArea";
import CountedAutoComplete from "../generic/inputs/CountedAutoComplete";
import LangTestInput from "../generic/inputs/LangTestScoreInput";
import ToggleResults from "./GenerationUI/ToggleResults";
import InputCluster from "../generic/inputs/InputCluster";
import dynamic from "next/dynamic";

// const { useCookies } = dynamic(() => import("react-cookie"), { ssr: false });
interface Size {
  value: string;
  label: string;
}
const sizeOptions: Array<Size> = [
  { value: "small", label: "Short" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Long" },
];
const Joyride = dynamic(() => import("react-joyride"), { ssr: false });
export const enum InputType {
  CountedTextInput,
  CountedTextArea,
  CountedAutoComplete,
  LanguageScoreInput,
  InputCluster,
}

interface inputPanelProps {
  formFields: any;
  defaultInputs: any;
  copies: any;
}

const InputPanel: React.FC<inputPanelProps> = ({
  formFields,
  defaultInputs,
  copies,
}) => {
  const sopSectionLength = useSelector((state: any) => state.sop.length);

  const [inputs, setInputs] = useState<any>(defaultInputs ?? {});
  const dispatch = useDispatch();
  const selector = useSelector((state: any) => state.sop);
  const router = useRouter();
  const [filledInputs, setFilledInputs] = useState<any>(defaultInputs);
  const { sopId, type } = router.query;
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [errorSubmission, setErrorSubmission] = useState<boolean>(false);
  const [contentPresent, setcontentPresent] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(true);
  //   const [cookies, setCookie] = useCookies(["joyrideDisplay"]);
  const [joyrideDisplayed, setJoyrideDisplayed] = useState(false);

  const handleChange = (e: any, key: string) => {
    setInputs((inputs: any) => {
      const newInputs = { ...inputs };
      if (typeof e?.target?.value == "object") {
        newInputs[key] = Object.values(e?.target?.value).join(" ");
      } else {
        newInputs[key] = e.target?.value;
      }
      dispatch(setReduxInputs(newInputs));
      setInputs(newInputs);
      return newInputs;
    });
  };
  useEffect(() => {
    const handleResize = () => {
      const isMediumViewport = window.innerWidth >= 768;
      if (
        isMediumViewport &&
        (formFields?.endpoint == "personalintro" ||
          formFields?.endpoint == "touristsubjectline")
      ) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    setFilledInputs(defaultInputs);
    setInputs(defaultInputs);
  }, [defaultInputs]);

  const handleGenerate = async () => {
    if (errorSubmission) {
      dispatch(
        setNotification({
          status: NotificationStatus.failed,
          message: "Please check all the fields",
        })
      );
      return;
    }
    setIsGenerating(true);
    try {
      const outputs: SOPCopyResult = await generateContent(
        formFields?.endpoint,
        inputs,
        sopId as string,
        type as string,
        sopSectionLength as string
      );
      if (outputs) {
        setcontentPresent(true);
      }
      dispatch(setCopies(outputs?.output_data));
      dispatch(setToggleResults(true));

      try {
        const sop = await getSop(sopId as string, type as string);
        dispatch(setGenerations(sop?.generations));
      } catch (e: any) {
        if (e?.message != "Request failed with status code 404") {
          dispatch(
            setNotification({
              status: NotificationStatus.failed,
              message: parseError(e) ?? "Something went wrong",
            })
          );
        }
      }
    } catch (e) {
      dispatch(
        setNotification({
          status: NotificationStatus.failed,
          message: parseError(e) ?? "Something went wrong",
        })
      );
    } finally {
      setIsGenerating(false);
    }
  };
  const [steps, setSteps] = useState<Step[]>([
    {
      target: ".fill-form",
      content: "Fill the form with all your details",
      disableBeacon: true,
      placement: "right",
      continuous: true,
    },
    {
      target: ".generate",
      content: "After filling the form , click here to generate the sections",
      disableBeacon: true,
      placement: "right",
    },
  ]);
  const customStyles = {
    buttonNext: {
      backgroundColor: "#232559",
    },
    buttonBack: {
      backgroundColor: "#232559",
      color: "white",
      borderRadius: "5px",
      padding: "9px",
      marginRight: "20px",
    },
    buttonSkip: {
      color: "#232559",
      fontSize: "17px",
    },
  };
  const handleJoyrideCallback = (data) => {
    if (data.status === "finished") {
      setJoyrideDisplayed(true);
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("joyrideDisplayedAtInput", "true");
      }
    }
  };
  const lengthOptions = sizeOptions.map((size: Size) => (
    <option
      className="hover:cursor-pointer hover:bg-black"
      key={size.label}
      value={size.value}
    >
      {size.label}
    </option>
  ));

  const shouldDisplayJoyride =
    visible &&
    !joyrideDisplayed &&
    (typeof localStorage === "undefined" ||
      !localStorage.getItem("joyrideDisplayedAtInput"));

  return (
    <>
      {shouldDisplayJoyride && (
        <Joyride
          steps={steps}
          styles={customStyles}
          showSkipButton={true}
          callback={handleJoyrideCallback}
          showProgress={true}
        />
      )}
      <div className="overflow-y-auto px-3 lg:px-4 fill-form">
        {formFields?.inputs.map((inp: any, index: number) => {
          if (inp.type == InputType.CountedTextInput) {
            return (
              <CountedInput
                defaultValue={filledInputs?.[inp.name] ?? ""}
                key={index}
                id={inp.name}
                label={inp.label}
                required={inp.required}
                minLength={inp.minLength}
                maxLength={inp.maxLength}
                onChange={(e: any) => handleChange(e, inp.name)}
                placeholder={inp.placeholder}
                description={inp.description}
                disabled={isGenerating}
                setErrorSubmission={setErrorSubmission}
                className="mb-5"
                assistance={inp.assistance}
                inputDependencies={inp.inputDependencies}
                helpType={inp.helpType}
                handleParentChange={handleChange}
              />
            );
          } else if (inp.type == InputType.CountedTextArea) {
            return (
              <CountedTextArea
                defaultValue={filledInputs?.[inp.name] ?? ""}
                key={index}
                id={inp.name}
                label={inp.label}
                required={inp.required}
                maxLength={inp.maxLength}
                onChange={(e: any) => handleChange(e, inp.name)}
                placeholder={inp.placeholder}
                description={inp.description}
                disabled={isGenerating}
                setErrorSubmission={setErrorSubmission}
                assistance={inp.assistance}
                inputDependencies={inp.inputDependencies}
                helpType={inp.helpType}
                inputs={inputs}
                handleParentChange={handleChange}
              />
            );
          } else if (inp.type == InputType.CountedAutoComplete) {
            return (
              <CountedAutoComplete
                defaultValue={filledInputs?.[inp.name] ?? ""}
                key={index}
                id={inp.name}
                label={inp.label}
                minLength={5}
                required={inp.required}
                maxLength={inp.maxLength}
                onChange={(e) => handleChange(e, inp.name)}
                placeholder={inp.placeholder}
                description={inp.description}
                disabled={isGenerating}
                setErrorSubmission={setErrorSubmission}
                options={inp.options}
              />
            );
          } else if (inp.type == InputType.LanguageScoreInput) {
            return (
              <LangTestInput
                defaultValue={filledInputs?.[inp.name] ?? ""}
                key={index}
                id={inp.name}
                label={inp.label}
                required={inp.required}
                maxLength={inp.maxLength}
                onChange={(e) => handleChange(e, inp.name)}
                placeholder={inp.placeholder}
                description={inp.description}
                disabled={isGenerating}
                setErrorSubmission={setErrorSubmission}
              />
            );
          } else if (inp.type == InputType.InputCluster) {
            return (
              <InputCluster
                key={index}
                label={inp.label}
                cols={1}
                inp={inp}
                filledInputs={filledInputs}
              >
                {inp.fields.map((nestedInput: any, index: number) => (
                  <CountedInput
                    defaultValue={filledInputs?.[nestedInput.name] ?? ""}
                    key={index + 25654}
                    id={nestedInput.name}
                    label={nestedInput.label}
                    required={nestedInput.required}
                    minLength={nestedInput.minLength}
                    maxLength={nestedInput.maxLength}
                    onChange={(e: any) => handleChange(e, nestedInput.name)}
                    placeholder={nestedInput.placeholder}
                    description={nestedInput.description}
                    disabled={isGenerating}
                    setErrorSubmission={setErrorSubmission}
                    className="mb-5"
                    assistance={nestedInput.assistance}
                    inputDependencies={nestedInput.inputDependencies}
                    helpType={nestedInput.helpType}
                    handleParentChange={handleChange}
                  />
                ))}
              </InputCluster>
            );
          }
        })}
        <div className="grid grid-cols-2 text-white gap-4 text-center mt-3 sticky bottom-0 bg-white w-full pt-3">
          <button
            type="button"
            className="generate rounded-xl px-6 bg-tootler-primary-900 py-3 text-base font-medium text-white    focus:outline-none focus:ring-2 focus:ring-offset-2 "
            onClick={() => {
              handleGenerate();
            }}
          >
            Start Generation
          </button>
          {type != "GTE" && (
            <select
              id="size"
              name="size"
              value={sopSectionLength}
              className=" text-center rounded-xl px-6 border hover:cursor-pointer border-tootler-primary-900 py-3 text-base font-medium text-tootler-primary-900 hover:bg-tootler-primary-100   focus:border-tootler-primary-500 "
              onChange={(e) => dispatch(setSopLength(e.target.value))}
            >
              {lengthOptions}
            </select>
          )}
        </div>
      </div>

      <GenerationLoading
        action="Generating options for you"
        open={isGenerating}
        setOpen={setIsGenerating}
      />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userInfo: state.main.userInfo,
    defaultInputs: state.sop?.inputs,
    copies: state.sop?.copies,
  };
};
export default connect(mapStateToProps)(InputPanel);
